/**
 * Pevné mezery za jednopísmennými předložkami/spojkami (a, i, k, o, s, u, v, z),
 * aby nezůstávaly osamocené na konci řádku. Projde všechny textové uzly na
 * stránce (kromě script/style/textarea/input a contenteditable), globálně —
 * nezávisí na tom, jestli text pochází z ACF pole, nebo je natvrdo v šabloně.
 */

const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "NOSCRIPT"]);
const PREDLOZKY = /(^|\s)([kKsSvVzZoOuUaAiI])\s+/g;

function pridatPevneMezery(root = document.body) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || SKIP_TAGS.has(parent.tagName) || parent.isContentEditable) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const nodes = [];
  let node;
  while ((node = walker.nextNode())) {
    nodes.push(node);
  }

  nodes.forEach((textNode) => {
    const nove = textNode.nodeValue.replace(PREDLOZKY, "$1$2 ");
    if (nove !== textNode.nodeValue) {
      textNode.nodeValue = nove;
    }
  });
}

function init() {
  pridatPevneMezery();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

export { pridatPevneMezery };
